export const environment = {
	production: true,
	webappName: 'KVVM Klant',
	appVersionAddon: '',
	api_endpoint: 'https://app.kvvm.nl/api/v1/',
	sentry: 'https://144581aa28c018fbf6661a6fd1ac3723@o4507735602298880.ingest.de.sentry.io/4508284172501072'
};
